
import { mapState } from 'vuex'
import tailwindConfig from '@/tailwind.config.js'

export default {
  data() {
    return {
      mapContainerId: 'StoreLocatorMap',
      googleMap: null,
      userMarker: null,
      markers: [],
    }
  },
  computed: {
    ...mapState('storeLocator', [
      'coordinates',
      'defaultCoordinates',
      'bounds',
      'coreLibrary',
      'mapsLibrary',
      'markerLibrary',
      'nearestStores',
      'selectedStore',
    ]),
  },
  watch: {
    coordinates: {
      handler() {
        this.setMapCenter(this.coordinates)
        try {
          const marker = this.getUserMarker()
          this.drawMarker(marker, this.coordinates)
        } catch (error) {
          this.handleError(error)
        }
      },
      deep: true,
    },
    defaultCoordinates: {
      handler() {
        this.setMapCenter(this.defaultCoordinates)
      },
      deep: true,
    },
    bounds: {
      handler() {
        this.fitMapBounds()
      },
      deep: true,
    },
    nearestStores() {
      this.drawStoreMarkers()
    },
    selectedStore() {
      this.updateMarkerStates()
      if (!this.selectedStore.latLng) {
        return
      }
      this.panToCoordinates(this.selectedStore.latLng)
    },
  },
  methods: {
    getGoogleMap() {
      if (!this.googleMap) {
        this.googleMap = new this.mapsLibrary.Map(document.getElementById(this.mapContainerId))
        // this.googleMap.setOptions({ styles: [{ featureType: 'poi', stylers: [{ visibility: 'off' }] }] })
      }

      return this.googleMap
    },
    getMarker() {
      return new this.markerLibrary.Marker()
    },
    getUserMarker() {
      if (!this.userMarker) {
        this.userMarker = this.getMarker()
        this.userMarker.setIcon({
          url: '/svg/store-locator/user.svg',
          scaledSize: {
            width: 40,
            height: 40,
          },
        })
      }

      return this.userMarker
    },
    panToCoordinates(coordinates) {
      this.getGoogleMap().panTo(coordinates)
    },

    setMarkerIcon(marker, hover = false) {
      const selectedIcon = '/svg/store-locator/store-marker-selected.svg'
      const hoveredIcon = '/svg/store-locator/store-marker-hover.svg'
      const defaultIcon = '/svg/store-locator/store-marker.svg'
      const unselectedIcon = hover ? hoveredIcon : defaultIcon
      const icon = this.storeIsSelected(marker.store) ? selectedIcon : unselectedIcon
      marker.setIcon({
        url: icon,
        scaledSize: {
          width: 40,
          height: 40,
        },
      })
    },
    setMarkerLabel(marker, labelText) {
      marker.setLabel({
        text: labelText,
        fontFamily: tailwindConfig.theme.extend.fontFamily.sans.join(),
        color: this.storeIsSelected(marker.store) ? '#fff' : tailwindConfig.theme.extend.colors.default,
        fontSize: '18px',
      })
    },
    handleError(error) {
      this.$emit('error', error)
    },
    setMapCenter(coordinates) {
      try {
        this.getGoogleMap().setCenter(coordinates)
      } catch (error) {
        this.handleError(error)
      }
    },
    fitMapBounds() {
      try {
        this.getGoogleMap().fitBounds(this.bounds)
      } catch (error) {
        this.handleError(error)
      }
    },
    drawMarker(marker, position) {
      marker.setPosition(position)
      marker.setMap(this.googleMap)
    },
    drawStoreMarkers() {
      this.clearStoreMarkers()
      const bounds = new this.coreLibrary.LatLngBounds()
      this.nearestStores.forEach((store, index) => {
        bounds.extend(store.latLng)
        const marker = this.getMarker()
        marker.store = store
        this.setMarkerIcon(marker)
        this.setMarkerLabel(marker, (index + 1).toString())
        this.addStoreMarkerListeners(marker)
        this.drawMarker(marker, store.latLng)
        this.markers.push(marker)
      })
      if (bounds.isEmpty()) {
        return
      }
      this.$store.commit('storeLocator/SET_BOUNDS', bounds)
    },
    clearStoreMarkers() {
      this.markers.forEach((marker) => {
        marker.setMap(null)
      })
      this.markers = []
    },
    storeIsSelected(store) {
      return store === this.selectedStore
    },
    addStoreMarkerListeners(marker) {
      marker.addListener('mouseover', () => {
        this.setMarkerIcon(marker, true)
      })
      marker.addListener('mouseout', () => {
        this.setMarkerIcon(marker)
      })
      marker.addListener('click', () => {
        this.$store.commit('storeLocator/SET_SELECTED_STORE', marker.store)
      })
    },
    updateMarkerStates() {
      this.markers.forEach((marker) => {
        this.setMarkerIcon(marker)
        this.setMarkerLabel(marker, marker.getLabel().text)
      })
    },
  },
}
